export default function HeroSection() {
  return (
    <section id="hero" className="relative w-full min-h-screen flex items-center bg-background-50">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6 py-20 md:py-0">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-accent-100/80 text-accent-700 text-xs font-medium mb-6 whitespace-nowrap">
              <i className="ri-fire-line"></i>
              <span>日漫韩漫国漫 · 一网打尽</span>
            </div>

            <h1 className="text-2xl md:text-4xl lg:text-5xl font-heading text-foreground-950 leading-tight">
              51动漫网 · 你的免费在线动漫追更站
            </h1>

            <p className="mt-3 text-base md:text-lg text-primary-500 font-medium">
              高清全集 · 下拉式阅读 · 日更不停歇
            </p>

            <p className="mt-6 text-sm md:text-base text-foreground-600 leading-relaxed max-w-xl mx-auto lg:mx-0">
              51动漫网汇聚了海量日漫、韩漫与国漫资源，采用流畅的下拉式阅读体验，让追更变得像刷短视频一样轻松。
              每日同步更新最新番剧，高清画质免费观看，无需注册即可畅享全集。无论你是热血少年还是文艺少女，
              这里都有属于你的那一部动漫。
            </p>

            <div className="mt-6 flex flex-wrap items-center justify-center lg:justify-start gap-6">
              <div className="flex items-center gap-2">
                <span className="text-2xl font-heading text-accent-500">20000+</span>
                <span className="text-xs text-foreground-500">部动漫资源</span>
              </div>
              <div className="w-px h-6 bg-background-300 hidden sm:block"></div>
              <div className="flex items-center gap-2">
                <span className="text-2xl font-heading text-accent-500">每日</span>
                <span className="text-xs text-foreground-500">同步更新</span>
              </div>
              <div className="w-px h-6 bg-background-300 hidden sm:block"></div>
              <div className="flex items-center gap-2">
                <span className="text-2xl font-heading text-accent-500">1080P</span>
                <span className="text-xs text-foreground-500">高清画质</span>
              </div>
            </div>

            <div className="mt-8 flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-4">
              <a
                href="#index"
                onClick={(e) => { e.preventDefault(); document.querySelector('#index')?.scrollIntoView({ behavior: 'smooth' }); }}
                className="inline-flex items-center gap-2 px-8 py-3 bg-primary-500 text-background-50 rounded-full text-sm font-medium hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-play-circle-line"></i>
                开始追漫
              </a>
              <a
                href="#ranking"
                onClick={(e) => { e.preventDefault(); document.querySelector('#ranking')?.scrollIntoView({ behavior: 'smooth' }); }}
                className="inline-flex items-center gap-2 px-8 py-3 border border-background-300 text-foreground-700 rounded-full text-sm font-medium hover:border-primary-400 hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-trophy-line"></i>
                查看热榜
              </a>
            </div>
          </div>

          <div className="flex-1 w-full flex justify-center">
            <div className="relative w-full max-w-[480px] aspect-[4/3] rounded-2xl overflow-hidden bg-background-100">
              <img
                src="https://readdy.ai/api/search-image?query=Vibrant%20colorful%20anime%20style%20illustration%20with%20multiple%20popular%20anime%20characters%20collage%2C%20dynamic%20composition%2C%20warm%20lighting%2C%20japanese%20manga%20aesthetic%2C%20action%20poses%2C%20bright%20orange%20and%20pink%20accents%2C%20clean%20background%2C%20commercial%20illustration%20quality&width=960&height=720&seq=hero-anime-2026&orientation=landscape"
                alt="51动漫网 - 热门动漫角色合集展示"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/10 to-transparent"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}